import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import ResetPasswordForm from 'components/ResetPasswordForm';
import { confirmNewPassword } from 'redux/actions/userActions';
import { getIdFromURL } from 'utils/misc';
import { withNamespaces } from 'react-i18next';
import { SubmissionError } from 'redux-form';


const ResetPassword = (props) => {
  const handleSubmit = async (formData) => {
    const token = getIdFromURL(props.location.pathname, 2);
    const uid = getIdFromURL(props.location.pathname, 3);

    try {
      await props.confirmNewPassword({
        uid,
        token,
        new_password1: formData.new_password1,
        new_password2: formData.new_password2,
      });
      props.history.push('/login');
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError({
          new_password2: error.errors.token
            ? 'You have to create a new password reset link'
            : error.errors.new_password2,
        });
      }
    }
  };

  return (
    <ResetPasswordForm onSubmit={data => handleSubmit(data)} />
  );
};

ResetPassword.propTypes = {
  confirmNewPassword: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  withRouter,
  withNamespaces('common'),
  connect(
    null,
    { confirmNewPassword },
  ),
)(ResetPassword);
